// Production URL for API

export const ApiUrl = "https://cms.fathimashrine.com/api";

// Development URL for API

// export const ApiUrl = "http://127.0.0.1:8000/api";